<script>
  // import Number from "./NumberInput.svelte";
  import Field from "../FormField.svelte";
  import moment from "moment";

  import { afterUpdate,createEventDispatcher } from "svelte";
  import {dateToWords} from "../application/store.js";
  export let dd = "";
  export let mm = "";
  export let yyyy = "";
  export let dob = "";
  export let dobStr;
  export let isValid = true;
  export let isDirty = false;
  export let isRequired = true;
  export let dateFrom, dateTo;
  let dayInput, monthInput, yearInput;
  let isDayValid = false, isDayDirty = false;
  let isMonthValid = false, isMonthDirty = false;
  let isYearValid = false, isYearDirty = false;
  export let allowDisable = false;


  let errorMessage = "", inputErr = "";
  let dayErr="",monthErr ="", yearErr ="";
  let validDate, dateDOB;
  const maxYear = new Date().getFullYear()+1;
  const minYear = new Date().getFullYear()-20;
  const dispatch = new createEventDispatcher();
 
  const dateWords = (d)=>{ 
    if( d == '' || !isValid)
    return '';       
    return dateToWords(d);
   //return dt.toLocaleString("default",{ year: 'numeric', month: 'long', day: 'numeric'});
  }
  $:{ 
    dateInWords = dateWords(dob);
}
 
  let dateInWords = "";
  if ( new Date(dob).getFullYear() == 1)
    dob = '';
  
  if (dob != "" && !isNaN(new Date(dob).getTime())) {
    //const dateArray = new Date(dob).toLocaleDateString().split("/");
  //  const dt =new Date(Date.UTC(dob));
  const dt=moment.utc(dob).toDate();    
   // dateInWords = dt.toLocaleString("default",{ year: 'numeric', month: 'long', day: 'numeric'});
    
    dd = dt.getUTCDate() < 10 ? '0' + dt.getUTCDate() : dt.getUTCDate();
    mm = (dt.getUTCMonth() + 1 )< 10 ? '0' + (dt.getUTCMonth() + 1) : dt.getUTCMonth() + 1;
    yyyy = dt.getUTCFullYear();
    isDayValid =true; isDayDirty = true;
    isMonthValid = true; isMonthDirty = true;
    isYearValid = true; isYearDirty = true;
    dobStr =  dd+'/'+mm+'/'+yyyy
  }

  let isRangeCheck = dateFrom != "" && dateTo != "";

  const isInRange = dateToCheck => {
    return dateToCheck >= dateFrom && dateToCheck <= dateTo;
  };
  $:{
    if(isDirty)
    { 
      isDayDirty = true;isMonthDirty=true;isYearDirty=true;
       if(isRequired && dob =="" && isValid)
     {
     isValid = false;
     isDayValid = dd !="";
     isMonthValid = mm !="";
     isYearValid = yyyy !="";

      errorMessage = "Date of Birth cannot be empty.<br/>";
     }
    }
  }

//   $: {

//     if (!isRequired && dob == "") isValid = true;

//     isValid = isDayValid  && isMonthValid && isYearValid;
//     isDirty = isDayDirty && isMonthDirty && isYearDirty;
//     if (isValid && isDirty)
//      {
//       dateDOB = new Date(Date.UTC(yyyy,mm-1,dd));
//  //  dateDOB =   Date.UTC(yyyy,mm,dd);
//       // if (isRangeCheck && !isInRange(dateDOB)) {
//       //   isValid = false;
//       //   errorMessage = "Please enter date between " + dateFrom.toLocaleDateString() + " and " + dateTo.toLocaleDateString();
//       // } else
//        if (isNaN(dateDOB.getTime())){
//         isValid = false;
//         errorMessage = "Please enter a valid date";
//       } else {
//         dob = dateDOB;//.toLocaleDateString();
//         dobStr = dd+'/'+mm+'/'+yyyy;//dateDOB.toLocaleDateString();   
//         dispatch("changed", dob);
//       }
      
//     }
//   }

  const validateInput = (input,label) => { 
    //   var label = input.labels[0].htmlFor;    
       inputErr="";
    let isDay =label == 'Day';
    let isMonth =label == 'Month';
    let isYear = label == 'Year';

 isDayValid = isDayValid;
 isMonthValid = isMonthValid;
 isYearValid = isYearValid;
    let isInputValid = false;
    var maxLength = parseInt(input.maxLength);
    var max = parseInt(input.max);
    var min = parseInt(input.min);
     var minLength = parseInt(input.minlength);
 
    if (isRequired && input.value == "") {
      isInputValid = false;
      if(isDay) dayErr = label + " can not be empty.<br/>";
      inputErr =label + " can not be empty.<br/>";
    } else if (input.value.length > maxLength) {
     // isValid = false;
      isInputValid = false;
      inputErr = 
        label + " can not exceed maximum allowed length of " + maxLength+"<br/>";
      //input.preventDefault();
    }else if (isYear &&  input.value.length < 4) {
     // isValid = false;
      isInputValid = false;
      inputErr = 
         "Year must be length of 4<br/>";
      //input.preventDefault();
    } else if (!isYear && (input.value > max || input.value < min)) {
   //   isValid = false;
      isInputValid = false;
      inputErr = label + " must be between " + min + " and " + max+"<br/>";
    } else if (input.value.length == 1) {
      input.value = "0" + input.value;
   //   isValid = true;
      isInputValid = true;
      inputErr = "";
    } else {
      isInputValid = true;
  //    isValid = true;
      inputErr = "";
    }

    if(isDay)   { isDayValid = isInputValid; dayErr = inputErr; isDayDirty = true;}
   if(isMonth) { isMonthValid = isInputValid; monthErr = inputErr; isMonthDirty = true;}
    if(isYear) { isYearValid = isInputValid; yearErr = inputErr; isYearDirty = true;}

  errorMessage = dayErr + monthErr + yearErr;

     if (!isRequired && dob == "") isValid = true;

    isValid = isDayValid  && isMonthValid && isYearValid;
    isDirty = isDayDirty && isMonthDirty && isYearDirty;
    if (isValid && isDirty)
     {
      //dateDOB = Date.UTC(yyyy,mm-1,dd);
      dateDOB = new Date(Date.UTC(yyyy,mm-1,dd));

 //  dateDOB =   Date.UTC(yyyy,mm,dd);
      // if (isRangeCheck && !isInRange(dateDOB)) {
      //   isValid = false;
      //   errorMessage = "Please enter date between " + dateFrom.toLocaleDateString() + " and " + dateTo.toLocaleDateString();
      // } else
       if (isNaN(dateDOB.getTime()) || dateDOB.getUTCDate() != Number(dd)){
        isValid = false;
        errorMessage = "Please enter a valid date";
      } else {
        dob = moment(dateDOB).utc();
        //dob = dateDOB;//.toLocaleDateString();      
        dobStr = dd+'/'+mm+'/'+yyyy;//dateDOB.toLocaleDateString();   
      //  const dt = new Date(dob);
        //dateInWords = dt.toLocaleString("default",{ year: 'numeric', month: 'long', day: 'numeric'});   
       // dispatch("changed", dob);
      }
       dispatch("changed", dob);
      
    }
    return isInputValid;
  };

  // to do: do not allow alphabets for firefox and ie  
  const checkNaN = evt => {
    var charCode = (evt.which) ? evt.which : evt.keyCode
         if ( charCode == 32 || (charCode > 31 && (charCode < 48 || charCode > 57)))         
          {
             evt.preventDefault();
               evt.returnValue = false;
          return false;
          }
         
       
  //   var charCode = e.which || e.keyCode;
  //   if (
  //     isNaN(e.target.value) ||
  //     charCode == 32 ||
  //     !((charCode > 47 && charCode < 58) || (charCode > 95 && charCode < 105))
  //   ) {
  //    // isValid = false;
      
  //     e.preventDefault();
    
  //   //  e.target.value = e.target.value.replace(/[^\d]/gi, ""); // var reg = /^\d+$/; !reg.test(this.value)
  //  //   errorMessage = "This field only accepts numbers.";
  //   }
  };


  afterUpdate(() => {
    // to do: do not allow alphabets for firefox and ie  
    //  dayInput.onkeypress = async function(e) { 
    //   if (dayInput.value.length >= dayInput.maxLength) e.preventDefault();
    //  } 
    dayInput.onkeypress = function(e) { checkNaN(e); }
    monthInput.onkeypress = function(e) { checkNaN(e); }
    yearInput.onkeypress = function(e) { checkNaN(e); }

   dayInput.onkeyup = function(e) {

      if(e.keyCode == 9)
        e.preventDefault();
      else if (dayInput.value.length >= dayInput.maxLength) {
        e.preventDefault();     
       // if (!isMonthValid)
        monthInput.focus();
      }
    };
    monthInput.onkeyup = function(e) {
      if (e.keyCode == 9)
        e.preventDefault();
      else if ( monthInput.value.length >= parseInt(monthInput.attributes["maxlength"].value)) {
        e.preventDefault();
        //if (isMonthValid) 
        yearInput.focus();
      }
    };

    yearInput.onkeyup = function(e) {
        
      if ( yearInput.value.length >= parseInt(yearInput.attributes["maxlength"].value)) {
        yearInput.blur();
        e.preventDefault();
       // if (isYearValid)
       
       // isYearValid = yearInput.blur();
//        return false;
      }
    };
  });
</script>

<div class="dob" style="display:flex;">

  
      <input
        aria-label="date"
        class="input {(!isDayValid || !isValid) && isDayDirty ? 'is-danger' : ''}"
        id="Day"
        maxlength="2"
        type="number"
        bind:value={dd}
        max="31"
        min="1"
        placeholder="DD"
        bind:this={dayInput}
        on:change={ isDayValid = validateInput(dayInput,"Day")} 
        style="width: 75px;margin-right: 10px;"
        disabled={allowDisable}/>

      <input
        aria-label="month"
        class="input {(!isMonthValid || !isValid) && isMonthDirty? 'is-danger' : ''}"
        id="Month"
        type="number"
        bind:value={mm}
        maxlength="2"
        max="12"
        min="1"
        label="Month"
        placeholder="MM"
        bind:this={monthInput}
        on:change={ isMonthValid = validateInput(monthInput,"Month")}        
        style="width: 75px;margin-right: 10px;"
         disabled={allowDisable}/> 

      <input
        aria-label="year"
        class="input {(!isYearValid || !isValid) && isYearDirty ? 'is-danger' :''}"
        id="Year"
        type="number"
        bind:value={yyyy}
        maxlength="4"        
        max={maxYear}
        min={minYear}
        label="Year"
        placeholder="YYYY"
        bind:this={yearInput}
        on:change={isYearValid = validateInput(yearInput,"Year")} 
        style="width: 90px;"
         disabled={allowDisable}/>
    



</div>

{#if !isValid}
<!-- <p class="help is-danger">{@html inputErr}</p> -->
  <p class="help is-danger">{@html errorMessage}</p>
{/if}


{#if dateInWords != '' && isValid}
<span  style="display:block;margin-top:5px;">
 <i> <b>({dateInWords})</b></i>
</span>
{/if}
